import { useQueries, UseQueryResult } from '@tanstack/react-query';

import { edgeStackQueryOptions } from '@/react/edge/edge-stacks/queries/useEdgeStack';
import { stackQueryOptions } from '@/react/common/stacks/queries/useStack';
import { EdgeStack } from '@/react/edge/edge-stacks/types';
import { Stack } from '@/react/common/stacks/types';

import { WorkflowArtifact, WorkflowType } from '../types';

export type MixedArtifactObject = EdgeStack | Stack;
export type MaybeArtifactObject = MixedArtifactObject | null | undefined;

export function isStack(maybe: MaybeArtifactObject): maybe is Stack {
  return !!maybe && 'Type' in maybe;
}

export function isEdgeStack(maybe: MaybeArtifactObject): maybe is EdgeStack {
  return !!maybe && !isStack(maybe);
}

export function isHelmObject(obj: MixedArtifactObject) {
  return (
    (isEdgeStack(obj) && !!obj.HelmConfig) ||
    (isStack(obj) && !!obj.HelmChartPath)
  );
}

export function getRealObject(
  data: MixedArtifactObject[],
  id: number,
  type: WorkflowType
) {
  return data.find(
    (i) =>
      id === i.Id &&
      ((type === 'edgeStack' && isEdgeStack(i)) ||
        (type === 'stack' && isStack(i)))
  );
}

export function useArtifactUnderlyingObjects(
  artifacts: Array<WorkflowArtifact>
): UseQueryResult<MaybeArtifactObject>[] {
  return useQueries({
    queries: artifacts.map((artifact) =>
      artifact.type === 'edgeStack'
        ? edgeStackQueryOptions(artifact.id)
        : stackQueryOptions(artifact.id)
    ),
  });
}
